<template>
    <el-dialog :title="title" :close-on-click-modal="false" :visible.sync="visible" width="1000px">
        <table style="margin-left:0px;">
            <tr>
                <td class="ttd">
                    <label slot="label">
                        <span>标的物</span>
                    </label>
                </td>
                <td colspan="2">
                    <el-row>
                        <span class="set_data">{{ dataForm.subjectName }}</span>
                    </el-row>
                </td>
                <td class="ttd">
                    <label slot="label">
                        <span>专业</span>
                    </label>
                </td>
                <td colspan="3">
                    <el-row>
                        <span class="set_data">{{ dataForm.majorName }}</span>
                    </el-row>
                </td>
            </tr>
            <tr>
                <td class="ttd">
                    <label slot="label">
                        <span>检验人</span>
                    </label>
                </td>
                <td colspan="2">
                    <el-row>
                        <span class="set_data">{{ dataForm.testMan }}</span>
                    </el-row>
                </td>
                <td class="ttd">
                    <label slot="label">
                        <span>检验时间</span>
                    </label>
                </td>
                <td colspan="3">
                    <el-row>
                        <span class="set_data">{{ dataForm.testDate | formatDate('yyyy-MM-dd') }}</span>
                    </el-row>
                </td>
            </tr>
            <tr>
                <td class="ttd">
                    <label slot="label">
                        <span>检验结论</span>
                    </label>
                </td>
                <td class="ttd test-result-header">
                    <label slot="label">
                        <span>1次检验</span>
                    </label>
                </td>
                <td class="test-result-data">
                    <el-row>
                        <span class="set_data">{{ dataForm.testConclusionName }}</span>
                    </el-row>
                </td>
                <td class="ttd test-result-header">
                    <label slot="label">
                        <span>2次检验</span>
                    </label>
                </td>
                <td class="test-result-data">
                    <el-row>
                        <span class="set_data">{{ dataForm.testConclusionName2 }}</span>
                    </el-row>
                </td>
                <td class="ttd test-result-header">
                    <label slot="label">
                        <span>2次以上检验</span>
                    </label>
                </td>
                <td class="test-result-data">
                    <el-row>
                        <span class="set_data">{{ dataForm.testConclusionName3 }}</span>
                    </el-row>
                </td>
            </tr>
            <tr>
                <td class="ttd">
                    <label slot="label">
                        <span>检验项目</span>
                    </label>
                </td>
                <td colspan="6">
                    <el-row>
                        <span class="set_data" style="text-align: left !important;">{{ dataForm.probContext }}</span>
                    </el-row>
                </td>
            </tr>
            <tr>
                <td class="ttd">
                    <label slot="label">
                        <span>检验意见</span>
                    </label>
                </td>
                <td colspan="6">
                    <el-row>
                        <span class="set_data" style="text-align: left !important;">{{ dataForm.sutContent }}</span>
                    </el-row>
                </td>
            </tr>
            <tr>
                <td class="ttd">
                    <label slot="label">
                        <span>备注</span>
                    </label>
                </td>
                <td colspan="6">
                    <el-row>
                        <span class="set_data" style="text-align: left !important;">{{ dataForm.remark }}</span>
                    </el-row>
                </td>
            </tr>
        </table>
        <el-row>
            <el-col :span="24" class="row-form-item">
                <div class="fileItem">报验照片（如有时）</div>
            </el-col>
        </el-row>
        <el-row style="margin-bottom: 10px;">
            <el-col :span="24" style="margin-top: 10px;">
                <el-upload ref="uploadImg" class="upload-demo" action="action" drag :http-request="uploadImg" multiple
                    :show-file-list=false :auto-upload="true" accept="image/jpeg,image/png,image/jpg"  :before-upload="beforeUploadSituation">
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将图片拖到此处，或<em>点击上传</em></div>
                </el-upload>
            </el-col>
            <el-col :span="24" style="margin-top: 30px;margin-bottom: 10px;">
                <el-table class="dataListTable" border header-align="center" v-if="dataForm.scenePhotoList.length > 0"
                    :data="dataForm.scenePhotoList" style="width: 100%;" :cell-style="{ padding: '0px' }">
                    <el-table-column type="index" label="No." width="60" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column label="图片" width="220" header-align="center">
                        <template slot-scope="scope">
                            <el-image style="height: 100px" :src="scope.row.thumbnailPathUri"
                                :preview-src-list="previewList(scope.row.thumbnailPathUri)" fit='contain'></el-image>
                        </template>
                    </el-table-column>
                    <el-table-column label="描述" width="475px" header-align="center">
                        <template slot-scope="scope">
                            <el-input type="textarea" rows="2"
                                v-model="dataForm.scenePhotoList[scope.$index].fileContent"
                                placeholder="请填写"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column label=" " width="103" align="center">
                        <template slot-scope="scope">
                            <el-button size="mini" type="danger" @click="delScenePhoto(scope.$index)">删除</el-button>
                        </template>
                    </el-table-column>
                    <el-table-column label="同步" width="80" header-align="center" align="center">
                        <template slot-scope="scope">
                            <el-checkbox :value="scope.row.synchroFlg === 1"
                                @change="(val) => (scope.row.synchroFlg = val ? 1 : 0)" class="sbox"
                                label=""></el-checkbox>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
        </el-row>
        <el-row class="formBtnGroup">
            <el-button v-preventReClick class="btn" type="primary" size="small" @click="dataFormSubmit()">确定</el-button>
            <el-button v-preventReClick class="btn" type="primary" size="small" @click="visible = false">取消</el-button>
        </el-row>
    </el-dialog>
</template>

<script>
import addImg from "@/assets/images/addImg.png"
import $common from "@/utils/common.js"
export default {
    name: "patrolList-Info",
    data() {
        return {
            title: '照片',
            addImg: addImg,
            testId: '',
            visible: true,
            showCloseItem: false,
            action: "",
            form: {},
            probCheck: '0',
            dataForm: {
                workNo: $common.getItem("workNo"),
                subjectNo: "",
                inspectionId: "",
                category: '',
                major: "",
                inspectionTime: "",
                inspectionPlace: "",
                inspectionMan: '',
                inspectionContent: '',
                photo: [],
                sutContent: '',
                scenePhotoList: [],
                closeFileList: [],
                closePhotoList: [],
                inspectionId: ''
            },
            dataRule: {
            }
        };
    },
    components: {

    },
    mounted() {
    },
    filters: {
        formatDate: function (value, args) {
            if (!value) {
                return ''
            }
            var dt = new Date(value);
            if (args == 'yyyy-M-d') {// yyyy-M-d
                let year = dt.getFullYear();
                let month = dt.getMonth() + 1;
                let date = dt.getDate();
                return `${year}-${month}-${date}`;
            } else if (args == 'yyyy-M-d H:m:s') {// yyyy-M-d H:m:s
                let year = dt.getFullYear();
                let month = dt.getMonth() + 1;
                let date = dt.getDate();
                let hour = dt.getHours();
                let minute = dt.getMinutes();
                let second = dt.getSeconds();
                return `${year}-${month}-${date} ${hour}:${minute}:${second}`;
            } else if (args == 'yyyy-MM-dd') {// yyyy-MM-dd
                let year = dt.getFullYear();
                let month = (dt.getMonth() + 1).toString().padStart(2, '0');
                let date = dt.getDate().toString().padStart(2, '0');
                return `${year}-${month}-${date}`;
            } else {// yyyy-MM-dd HH:mm:ss
                let year = dt.getFullYear();
                let month = (dt.getMonth() + 1).toString().padStart(2, '0');
                let date = dt.getDate().toString().padStart(2, '0');
                let hour = dt.getHours().toString().padStart(2, '0');
                let minute = dt.getMinutes().toString().padStart(2, '0');
                let second = dt.getSeconds().toString().padStart(2, '0');
                return `${year}-${month}-${date} ${hour}:${minute}:${second}`;
            }
        }
    },
    methods: {
        goBack() {
            this.$router.back()
        },
        init(id) {
            this.dataForm = {
                scenePhotoList: [],
                closeFileList: [],
                closePhotoList: [],
                inspectionId: this.inspectionId
            }
            this.testId = id ? id : '';
            this.getDetail();
            this.$nextTick(() => {
                this.visible = true;
            });

        },
        selectFile(url, filename) {
            filename = this.getSuffix(url, filename)
            this.getBlob(url, (blob) => {
                this.saveAs(blob, filename)
            })
        },
        getSuffix(url, filename) {
            let lastIndex = url.lastIndexOf(".");
            return filename + url.substr(lastIndex)
        },
        getBlob(url, cb) {
            var xhr = new XMLHttpRequest()
            xhr.open('GET', url, true)
            xhr.responseType = 'blob'
            xhr.onload = function () {
                if (xhr.status === 200) {
                    cb(xhr.response)
                }
            }
            xhr.send()
        },
        saveAs(blob, filename) {
            if (window.navigator.msSaveOrOpenBlob) {
                navigator.msSaveBlob(blob, filename)
            }
            else {
                var link = document.createElement('a')
                var body = document.querySelector('body')

                link.href = window.URL.createObjectURL(blob)
                link.download = filename

                link.style.display = 'none'
                body.appendChild(link)

                link.click()
                body.removeChild(link)
                window.URL.revokeObjectURL(link.href)
            }
        },
        getDetail() {
            this.$http({
                url: this.$store.state.httpUrl + "/business/testrecord/info/" + this.testId,
                method: "get",
                params: {},
            }).then(({ data }) => {
                if (data && data.resultCode === 200) {
                    this.dataForm = data.body;
                    // 判断是否是有条件接受，是则展示封闭照片与文件模块
                    // if(this.dataForm.finalTestConclusion == '2') {
                    //     this.showCloseItem = true
                    // } else {
                    //     this.showCloseItem = false
                    // }

                }
            });
        },
        beforeUploadSituation(file) {
			const isValidType = file.type === 'image/jpeg' ||
				file.type === 'image/png' ||
				file.type === 'image/jpg'

			if (!isValidType) {
				this.$message.error('只能上传 JPG/PNG 格式的图片！')
				return false
			}
			return true
		},
        // 删除现场照片
        delScenePhoto(index) {
            let _scenePhotoList = this.dataForm.scenePhotoList;
            _scenePhotoList.splice(index, 1);
            this.dataForm.scenePhotoList = _scenePhotoList;
        },
        // 上传照片
        uploadImg(param) {
            const formData = new FormData();
            formData.append('file', param.file);
            this.$refs.uploadImg.clearFiles();
            this.$http.post(
                this.$store.state.httpUrl + "/file/upload/" + $common.getItem("workNo") + "/10/0",
                formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            },
            ).then(res => {
                res = res.data
                if (res.resultCode == 200) {
                    this.dataForm.scenePhotoList.push({
                        testId: this.testId,
                        recFileType: '0',
                       fileName: res.body.fileName,
                        filePath: res.body.fileSavePath,
                        fileUri: res.body.fileUri,
                        fileContent: this.extractFileName(res.body.fileName),
                        thumbnailPath: res.body.thumbnailPath,
                        thumbnailPathUri: res.body.thumbnailPathUri,
                        compressedPath: res.body.compressedPath,
                        synchroFlg: '0'
                    });
                } else {
                    this.$message.info('文件上传失败')
                }
            })
        },
        previewList(fileUri) {
            return [fileUri]
        },
        extractFileName(fileName) {
            let index = fileName.lastIndexOf(".");
            return fileName.substr(0, index)
        },
        dataFormSubmit() {
            this.dataForm.testId = this.testId
            let _url = "/business/testrecordfile/save";
            this.$http({
                url: this.$store.state.httpUrl + _url,
                method: "post",
                data: this.$http.adornData(this.dataForm)
            }).then(({ data }) => {
                if (data && data.resultCode === 200) {
                    this.$message({
                        message: "操作成功",
                        type: "success",
                        duration: 1500,
                        onClose: () => {
                            this.visible = false;
                        }
                    });
                }
            });
        }
    }
};
</script>

<style scoped="scoped">
.addImgBox {
    width: 180px;
    height: 180px;
    display: inline-block;
    vertical-align: middle;
    margin-right: 10px;
}
::v-deep(.upload-demo .el-upload-dragger) {
    width: 940px;
    height: 100px;
    margin-bottom: -30px;
}

::v-deep(.upload-demo .el-upload-dragger .el-icon-upload) {
    font-size: 30px;
    margin: 20px 1px;
    line-height: 20px;
}

::v-deep(.upload-demo .el-upload-dragger .el-upload__text) {
    line-height: 5px;
}

.sp-input /deep/ .el-input__inner {
    width: 100% !important;
}

.item::v-deep .el-form-item__label {
    color: #00428e !important;
    margin-right: 10px !important;
    font-weight: bold !important;
    align-items: center;
    background-color: #E1F1FF !important;
    border-right: 1px solid #dadada !important;
    white-space: normal;
    font-size: 12px !important;
    word-break: break-all;
}

::v-deep .el-form-item {
    display: flex !important;
    align-items: stretch !important;
    margin-bottom: 0px !important;
}

.item::v-deep .el-form-item__content {
    display: flex;
    align-items: center;
    white-space: normal;
    word-break: break-all;
    flex: 1;
    font-size: 12px !important;
    padding: 2px 0 !important;
    /* 减少内边距 */
    line-height: 1.4;
    /* 设置统一的行高 */
}

.border-form .el-row.set_border {
    border-bottom: 1px solid #dadada;
    border-left: 1px solid #dadada;
    border-right: 1px solid #dadada;
}

.border-form .el-row.set_border:first-child {
    border-top: 1px solid #dadada;
}

.border-form .el-row.set_border .col-set_border {
    border-right: 1px solid #dadada;
}

::v-deep .el-dialog__header {
    height: 60px;
    line-height: 30px;
}

.set_data {
    display: inline-block;
    line-height: 1.4;
    margin: 0 !important;
    padding: 2px 5px !important;
    min-height: 22px;
    font-size: 12px;
}

table {
    border-collapse: collapse;
    width: 100%;
}

th,
td {
    border: 1px solid #dadada;
    padding: 2px;
    text-align: center;
    font-size: 14px !important;
}

.ttd {
    background-color: #E1F1FF;
    width: 15%;
    text-align: right;
    padding: 8px 15px;
    color: #00428E !important;
    font-size: 12px;
    font-weight: bold;
}

.test-result-header {
    width: 12%;
}

.test-result-data {
    width: 12%;
}

.sbox::v-deep .el-checkbox__inner::after {
    margin-left: 1px;
}
</style>
